import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Color from './Color';

const styles = {
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    marginTop: 5,
    marginBottom: 10
  },
  text: {
    backgroundColor: Color.backgroundTransparent,
    color: Color.defaultColor,
    fontSize: 12,
    fontWeight: '300',
    textAlign: 'center'
  }
};

export default class SystemMessage extends Component {
  render() {
    const { currentMessage, containerStyle, wrapperStyle, textStyle } = this.props;
    if (currentMessage) {
      return (
        <div style={{ ...styles.container, ...containerStyle }}>
          <div style={wrapperStyle}>
            <div style={{ ...styles.text, ...textStyle }}>{currentMessage.text}</div>
          </div>
        </div>
      );
    }
    return null;
  }
}
SystemMessage.defaultProps = {
  currentMessage: {
    system: false
  },
  containerStyle: {},
  wrapperStyle: {},
  textStyle: {}
};
SystemMessage.propTypes = {
  currentMessage: PropTypes.object,
  containerStyle: PropTypes.object,
  wrapperStyle: PropTypes.object,
  textStyle: PropTypes.object
};
//# sourceMappingURL=SystemMessage.js.map
